import { render, staticRenderFns } from "./ot-organisation-user-details.vue?vue&type=template&id=8c546594&scoped=true&"
import script from "./ot-organisation-user-details.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-user-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-user-details.vue?vue&type=style&index=0&id=8c546594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c546594",
  null
  
)

export default component.exports